export default "__VITE_ASSET__wLf2IJUu__"